<template>
  <AppConfirmationModal v-bind="$attrs" persistent max-width="550px" :loading="loading">
    <template v-slot:title>{{header}}</template>
    <template v-slot:text>
      <div v-html="title" />
      <v-card>
        <v-card-text>
          <slot v-if="dataTypeArray" name="item-list">
            <v-list>
              <v-list-tile v-for="item in data" v-bind:key="item">
                <v-list-tile-content>{{item}}</v-list-tile-content>
              </v-list-tile>
            </v-list>
          </slot>
          <slot v-else name="item">
            {{data}}
          </slot>
        </v-card-text>
      </v-card>
    </template>
    <template v-slot:actions>
      <v-spacer />
      <v-btn @click="$store.dispatch('app/closeErrorDialog')">{{ $t('Button.Close') }}</v-btn>
    </template>
  </AppConfirmationModal>
</template>

<script>
  import AppConfirmationModal from '@/components/generic/AppConfirmationModal'
  export default {
    components: {
      AppConfirmationModal,
    },
    props: {
      data: {
        type: [Array, String],
        default: '',
      },
      loading: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: '',
      },
      header: {
        type: String,
        default: 'Error occurred',
      },
    },
    computed: {
      dataTypeArray() {
        return this.data instanceof Array
      },
    },
    methods: {
      _emitClose() {
        this.$emit('close')
      },
    },
  }
</script>

<style scoped>
  .error-detail-body {
    padding: 12px 24px;
  }
</style>